import MappingTabs from './MappingTabs'
export default MappingTabs



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/index.js